export enum LayoutColumnComponents {
  IMPERSONATION = -2,
  DEV_TOOLS = -1,
  LAYOUT_CONTROLS = 0,
  ORDER_LIST = 1,
  INSTRUCTION_LIST = 2,
  FILE_VIEWER = 3,
  MAP = 4,
  APP = 5,
  // Values 6, 8 and 9 belonged to removed prototypes; never reuse persisted IDs.
  PRODUCTION_STATEMENT = 7,
  INSTRUCTION_FINDER = 10,
  INVOICE = 11,
  QUOTE = 12,
  WORKSPACE = 13,
  AI_CONTROL_SETTINGS = 14,
  PLANMEISTER = 15
}
